export default "__VITE_ASSET__4698928b__"